import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";
import DashboardWrapper from "../../components/DashboardWrapper";
import { useTheme } from "@emotion/react";
import { getCategoryList } from "../../http/auth";
import Spinner from "../../components/Spinner";
import CategoryTable from "./CategoryTable";

export default function ManageCategories() {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("Income");
  const [totalCount, setTotalCount] = useState(0);
  const [nextId, setNextId] = useState("");
  //change according to the usertype

  const column = [
    { id: "sr", label: "Sl. No.", minWidth: 40 },
    { id: "title", label: "Category", minWidth: 140, sortable: true },
    { id: "action", label: "Action", minWidth: 60 },
  ];

  useEffect(() => {
    if (type === "Expenses") {
      const newData = [...columns];
      newData.splice(2, 0, {
        id: "subTitle",
        label: "subCategory",
        minWidth: 120,
      });
      setColumns(newData);
    } else {
      setColumns(column);
    }
  }, [type]);

  useEffect(() => {
    setPage(1);
    getCategories(type.toLowerCase(), 1);
  }, [type]);

  async function getCategories(cat, pageArg) {
    try {
      setLoading(true);
      const pg = pageArg ? pageArg : page;
      const response = await getCategoryList(cat, pg);
      const categories = response?.data?.data?.category;
      if (categories) updateRows(categories, pg);
      setTotalCount(response.data?.data?.totalCategory);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  function createData(sr, title, subTitle, action, id) {
    return { sr, title, subTitle, action, id };
  }

  const updateRows = (categories, pageArg) => {
    const list = categories.map((item, index) => {
      return createData(
        (pageArg - 1) * 10 + 1 + index + 1,
        item.title || "",
        item.subTitle || "",
        "-",
        item._id
      );
    });
    const updatedList = nextId ? [...rows, ...list] : list;
    setRows(updatedList);
  };

  const onNextClick = async () => {
    setPage(page + 1);
    getCategories(type.toLowerCase(), page + 1);
  };

  const onPrevClick = async () => {
    setPage(page - 1);
    getCategories(type.toLowerCase(), page - 1);
  };

  return (
    <DashboardWrapper>
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
          boxShadow: "none",
        }}
      >
        <>
          {!loading ? (
            <CategoryTable
              type={type}
              setType={setType}
              smScreen={smScreen}
              columns={columns}
              rows={rows}
              page={page}
              setPage={setPage}
              nextId={nextId}
              rowsPerPage={10}
              setLoading={setLoading}
              onPrevClick={onPrevClick}
              onNextClick={onNextClick}
              totalCount={totalCount}
              getCategories={getCategories}
            />
          ) : (
            <Spinner />
          )}
        </>
      </Paper>
    </DashboardWrapper>
  );
}
